// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PrebookInfo__wrapper___1hBzU","buttons":"PrebookInfo__buttons___1Yhor"};